module.exports = __webpack_public_path__ + "static/media/123.793811d.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/123.mp4
// module id = QW1p
// module chunks = 0